import { render } from "./CurrentTime.vue?vue&type=template&id=4ff64705&scoped=true"
import script from "./CurrentTime.vue?vue&type=script&lang=js"
export * from "./CurrentTime.vue?vue&type=script&lang=js"

import "./CurrentTime.vue?vue&type=style&index=0&id=4ff64705&scoped=true&lang=scss"

import exportComponent from "/opt/tracking-bg-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ff64705"]])

export default __exports__